document.addEventListener("DOMContentLoaded", () => {
let header = document.querySelector(".td-nav");
  let announcementBar = document.querySelector(".td-announcement-bar");
  let allMegaMenus = document.querySelectorAll(".menu-item-has-children.menu-item-has-megamenu");
  const homepageOverlap = document.querySelector(".td-hero__image-dsk");
  const mobileHomepageOverlap = document.querySelector(".td-hero__section-wrapper");
  const mobileHeading = document.querySelector(".header-section");

  if (header) {
      if (allMegaMenus.length > 0) {
          allMegaMenus.forEach((mega) => {
              mega.addEventListener("mouseenter", () => {
                  header.classList.add('td-nav__border');
                  if (homepageOverlap) {
                    homepageOverlap.classList.add('td-hero__menu-open');
                  }
              });
              mega.addEventListener("mouseleave", () => {
                  header.classList.remove('td-nav__border');
                  if (homepageOverlap) {
                    homepageOverlap.classList.remove("td-hero__menu-open");
                  }
              });
          });
      }

      document.addEventListener("nav:open", () => {
          header.classList.add('td-nav__border');
          if (mobileHomepageOverlap) {
            mobileHomepageOverlap.classList.add('td-hero__menu-open');
          }
          if (mobileHeading) {
            mobileHeading.classList.add('td-hero__menu-open--heading');
          }
      });

      document.addEventListener("nav:close", () => {
          header.classList.remove('td-nav__border');
          if (mobileHomepageOverlap) {
            mobileHomepageOverlap.classList.remove('td-hero__menu-open');
          }
          if (mobileHeading) {
            mobileHeading.classList.remove('td-hero__menu-open--heading');
          }
      });

      function updateHeaderPosition() {
          if (header && announcementBar) {
              if (elementsOverlap(header, announcementBar)) {
                  header.style.top = announcementBar.offsetHeight.toString() + "px";
                  header.classList.remove('td-nav__scroll');
              } else {
                  header.style.top = '10px';
                  header.classList.add('td-nav__scroll');
              }
          } else if (header) {
              header.style.top = '10px';
          }
      }

      // Run on page load
      updateHeaderPosition();

      // Run on scroll
      document.addEventListener('scroll', updateHeaderPosition);

      header.querySelectorAll("a").forEach(link => {
          link.addEventListener("click", function(event) {
              if (link.hostname !== window.location.hostname) {
                  event.preventDefault();
                  window.open(link.href, "_blank");
              }
          });
      });
  }

  // Mobile menu: open every submenu at the top of the drawer.
  // header.js has a scroll reset for this but it is gated on `.parent-link-back--button`,
  // a class the markup never renders, so the drawer keeps the parent menu's scroll position.
  const mobileMenu = document.getElementById("mobile-menu");

  if (mobileMenu && !mobileMenu.dataset.tdSubmenuScrollInit) {
      mobileMenu.dataset.tdSubmenuScrollInit = "true";
      mobileMenu.addEventListener("click", (event) => {
          if (event.target.closest("summary")) {
              mobileMenu.scrollTop = 0;
          }
      });
  }

  function elementsOverlap(el1, el2) {
      const domRect1 = el1.getBoundingClientRect();
      const domRect2 = el2.getBoundingClientRect();

      return !(
          domRect1.top > domRect2.bottom ||
          domRect1.right < domRect2.left ||
          domRect1.bottom < domRect2.top ||
          domRect1.left > domRect2.right
      );
  }
});
